// Up-to-two-letter avatar initials. Extracted from the copies that every table
// column module, drawer and picker used to define for itself; new callers use
// this. Pairs with avatarTone — the same seed feeds both.

/** "Hassan Umar" → "HU". Up to two leading letters, uppercased. */
const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');

export default initialsOf;
